import { ComponentType, lazy } from 'react'

import { retryAsync } from './universal'

export const lazyComponent = <T extends { default: ComponentType }>(
  fn: () => Promise<T>,
  maxRetries?: number
) => {
  return lazy(() => retryAsync(fn, maxRetries))
}
